import { API } from "../../../utils";
export const getTenantContactSettingsApi = async () => {
    const res = await API.get("/settings/contact");
    return res.data;
};

export const updateTenantContactSettingsApi = async (payload) => {
  const res = await API.put("/settings/contact", payload);
  return res.data;
};
